webpackJsonp([60314985830416],{

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'db.json'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore includes ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/typicode/json-server' },
	        'json-server'
	      ),
	      ' in all new projects, which provides an easy way to mock out a REST API. This file is what ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'json-server'
	      ),
	      ' uses to represent the database that backs it.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sometimes, you find yourself in a position where you get to develop a shiny new front-end against an existing REST API, and in that situation, this file isn\'t very useful. But when you\'re creating a new project from scratch, it can be a lot more useful.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Why include json-server?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'JSON Server is included by default due to the project\'s ease of use, excellent feature support (including pagination, search, and relationship expansion) and overall ability to help bootstrap new projects.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Developing an API is a non-trivial endeavor, and sometimes, you just want to mess around on the front-end, maybe play with a new library. This lets you do that.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'At the beginning of new projects, there often is no API. This gives you an easy way to mock one out until the real thing comes along.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Sometimes you find a bug in an API endpoint that negatively impacts your ability to continue front-end development. You could use this file to mock out just that endpoint, so you can keep moving forward, until the real endpoint is fixed.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Other reasons!'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'So ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'json-server'
	      ),
	      ' is included by default because it\'s super useful! And with this ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'db.json'
	      ),
	      ' file backing it, you can easily view and edit the data that gets served.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you\'d like to learn more about all the awesome things ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'json-server'
	      ),
	      ' can do, see the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/typicode/json-server' },
	        'json-server documentation'
	      ),
	      ' on GitHub.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file is empty by default.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here is an example file of what ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'db.json'
	      ),
	      ' might look like when it\'s populated. This data is taken from the Quickstart.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        "users": [\n          {\n            "id": 1,\n            "nickname": "ayla",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027069/a356e82a-88e1-11e6-87d8-e3e74f55c069.png"\n          },\n          {\n            "id": 2,\n            "nickname": "crono",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027070/a3659c76-88e1-11e6-8434-5d66c70956c7.png"\n          },\n          {\n            "id": 3,\n            "nickname": "frog",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027071/a36ef028-88e1-11e6-9756-5e35b6fed834.png"\n          },\n          {\n            "id": 4,\n            "nickname": "lucca",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n          },\n          {\n            "id": 5,\n            "nickname": "magus",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027073/a36f67f6-88e1-11e6-9168-7687083cb994.png"\n          },\n          {\n            "id": 6,\n            "nickname": "marle",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027074/a37105c0-88e1-11e6-9645-3e1af37671f7.png"\n          },\n          {\n            "id": 7,\n            "nickname": "robo",\n            "avatar": "https://cloud.githubusercontent.com/assets/2637399/19027075/a3719e2c-88e1-11e6-9abe-5186abc4b04d.png"\n          }\n        ],\n        "tweets": [\n          {\n            "id": 1,\n            "userId": 1,\n            "text": "Ayla fight while alive! Win and live. Lose and die. Rule of life. No change rule.",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          },\n          {\n            "id": 2,\n            "userId": 2,\n            "text": "What ARE you two doing? I thought you said something about a nice little slideshow?",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          },\n          {\n            "id": 3,\n            "userId": 3,\n            "text": "Ma\'am, you\'re mistaken, I\'m not a pet, I\'m a Knight and master swordsman.",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          },\n          {\n            "id": 4,\n            "userId": 4,\n            "text": "Nothing can beat science!",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          },\n          {\n            "id": 5,\n            "userId": 5,\n            "text": "I never imagined that we would settle our score in this dusty old era. Come, let us finish this charade!",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          },\n          {\n            "id": 6,\n            "userId": 6,\n            "text": "Crono!! We can\'t keep sponging off my dad! Go and get a job!!",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          },\n          {\n            "id": 7,\n            "userId": 7,\n            "text": "Something is written in archaic script. I will translate... R...o...i...h...c...l...e...m? Roihclem? System error! I reversed it! It says \\"Melchior!\\".",\n            "createdAt": "2016-11-26T04:03:25.546Z"\n          }\n        ]\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-db-js-249ba14eb12ae3dce4d7.js